import React, { Fragment } from 'react'
import styled from 'styled-components'

const ApiMethodTitleWrapper = ({ attributes, children, element, editor }) => (
  <ApiMethodTitle {...attributes}>{children}</ApiMethodTitle>
)

export default ApiMethodTitleWrapper

const ApiMethodTitle = styled.div`
  display: flex;
  margin-bottom: 20px;
  align-items: center;
`
